import { get_loggedInAsContractorugpccxnrffn6 as get_loggedInAsContractor } from '../../../selectedContractor.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_dp28ag147e4p5cz as get_dp,
  get_rem14pbkv8p42gid as get_rem,
  minus1paei8txflgx9 as minus,
  get_rem2p56fiaxda5jo as get_rem_0,
  get_px8ok5q0jdway2 as get_px,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { get_navExists2s7t7g61yra64 as get_navExists } from './crowpay.mjs';
import {
  shownDefaultFalse3hpz4awymyomc as shownDefaultFalse,
  resize3py5p2yrjp6p7 as resize,
} from '../../../utils/utils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { applySafeInsets3lsxkfxcwtdd8 as applySafeInsets } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/safeInsetsHelpers.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from './AppDimensions.mjs';
import { space2ppi73m2qk1br as space } from '../space.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance,
  Companion_getInstance3e8hrj2m27b5h as Companion_getInstance_0,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  get_simpleHome2r0gn0zind8aj as get_simpleHome,
  get_projects2fiwerrdoecdv as get_projects,
  get_clients1wsgh9ab0oq6r as get_clients,
  get_workList1e3ibv4j8g6ye as get_workList,
  get_messageBubble2n8cudx7fa50g as get_messageBubble,
  get_finances1ghbzv98ah6rc as get_finances,
  get_edit2tiiawv2658bs as get_edit,
  get_barGraphReport1klkvdhnbdofl as get_barGraphReport,
  get_bank374yxon6d2xhn as get_bank,
  get_notificationBellOutline14r67hvzgwl2y as get_notificationBellOutline,
} from '../../../icons.mjs';
import {
  MemberRole_Employee_getInstance37kv78awnpbvk as MemberRole_Employee_getInstance,
  MemberRole_Manager_getInstance3dbaoot8q9evq as MemberRole_Manager_getInstance,
  MemberRole_Admin_getInstance3iiznt2spfc6m as MemberRole_Admin_getInstance,
  UserRole_Admin_getInstance3u101dj1ubbhu as UserRole_Admin_getInstance,
} from '../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  get_expanding10cuv3ua9vajx as get_expanding,
  get_centered1xfu6or5nc0lq as get_centered,
  get_atTop15ygil3ceeuhl as get_atTop,
  get_atTopCenter1v6irntzl0tu6 as get_atTopCenter,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  shownWhenxgf1ujy6rmvr as shownWhen,
  weightt34o7llf2uyq as weight,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { greySeparatory5mpcoeivng5 as greySeparator } from '../../theming/separators.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { icon1sxjaie5w1apt as icon } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  BoldSemantic_getInstance3sy4hmow8wwn9 as BoldSemantic_getInstance,
  bodyBold2czwdzwknab0k as bodyBold,
  body3i5t0n7zprpqb as body,
} from '../../theming/Titles.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  TestServerSemantic_getInstance3job4xjohh5n6 as TestServerSemantic_getInstance,
  get_appThemejy2o9bdilpry as get_appTheme,
  MobileNavSemantic_getInstance35ah13hrpn1em as MobileNavSemantic_getInstance,
} from '../../theming/appTheme.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  get_selectedApi2skzkr2pn0lot as get_selectedApi,
  getDefaultServerBackend2jor6mvf4ze21 as getDefaultServerBackend,
  ApiOption_Production_getInstanceca14cdl7io88 as ApiOption_Production_getInstance,
  Companion_getInstancecudcwq8yu3m7 as Companion_getInstance_1,
} from '../../../sdk/apiOptions.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  UnselectedSemantic_getInstancexnnq5hq6ryv2 as UnselectedSemantic_getInstance,
  SelectedSemantic_getInstance3ef29ujazc52t as SelectedSemantic_getInstance,
  ButtonSemantic_getInstance2exl8jbak13ac as ButtonSemantic_getInstance,
  Set2awzlbbrsme5i as Set,
  NavSemantic_getInstance3ooa6be5xy9hs as NavSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { MenuButton27en4jjgdkozz as MenuButton } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/MenuButton.commonHtml.mjs';
import { Link2eefk0yp041c4 as Link } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Link.commonHtml.mjs';
import { dynamicThemexp3sdnaolntz as dynamicTheme } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { get_rawSession1kjo1nj4tz6n0 as get_rawSession } from '../../../sdk/UserSession.mjs';
import { ContractorDashboardpd20b7ol1l5h as ContractorDashboard } from '../../screens/contractor/ContractorDashboard.mjs';
import { ClientDashboard2uxyaz2oxv2st as ClientDashboard } from '../../screens/client/ClientDashboard.mjs';
import { ContractorProjects2hltgp2s6pm9i as ContractorProjects } from '../../screens/contractor/ContractorProjects.mjs';
import { ClientProjectsuhqipbst20fz as ClientProjects } from '../../screens/client/ClientProjects.mjs';
import { ContractorClientsflh7jhpyocdp as ContractorClients } from '../../screens/contractor/ContractorClients.mjs';
import {
  ContractorWorkLists2gwrvh4dcfppr as ContractorWorkLists,
  ClientWorkListsm2d5ivw4fy3k as ClientWorkLists,
} from '../../screens/common/WorkListsScreen.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import {
  ProjectLens_Customer_getInstancedmuwwz4nvrem as ProjectLens_Customer_getInstance,
  ProjectLens_Contractor_getInstance3hm6gxlnsv3ks as ProjectLens_Contractor_getInstance,
} from '../../screens/common/ProjectView.mjs';
import { singleOrNullrknfaxokm1sl as singleOrNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { ProjectMessageThread3bzm1pe4dp4n as ProjectMessageThread } from '../project/activity/messages.mjs';
import { MessagingScreen3v4v784hye3oc as MessagingScreen } from '../../screens/common/MessagingScreen.mjs';
import { ContractorPayments3j77ex8prycqi as ContractorPayments } from '../../screens/contractor/ContractorPayments.mjs';
import { ClientPayments2dnqnm01pn8b5 as ClientPayments } from '../../screens/client/ClientPayments.mjs';
import { SelectDevProjectScreenktpl27uiowry as SelectDevProjectScreen } from '../../screens/common/DevProjectView.mjs';
import { AdminReportingPage2yeyg5apo8s8x as AdminReportingPage } from '../../screens/admin/AdminReportingPage.mjs';
import { AdminExternalDepositPage3utp9dihxm4p as AdminExternalDepositPage } from '../../screens/admin/AdminExternalDepositPage.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  ContractorNotificationSettings1wc9spupzmetl as ContractorNotificationSettings,
  ClientNotificationSettings1m4d3pbyj6bl9 as ClientNotificationSettings,
} from '../../screens/common/NotificationSubscriptionSettings.mjs';
import { Specifications3c29ii5k9j2f7 as Specifications } from '../../screens/contractor/Specifications.mjs';
import { ManageContractorUsers27kb1m7q8tkdk as ManageContractorUsers } from '../../screens/contractor/ManageContractorUsers.mjs';
import { toggle2o6h9frvgo8sq as toggle } from '../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { UserNotifications_getInstance3eyit5zuwe2sg as UserNotifications_getInstance } from './UserNotifications.mjs';
import {
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_unpadded3gipn3ftxgnwh as get_unpadded,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { closePopovers89geeulkriez as closePopovers } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/ViewContextExtensions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_mostRecentNavSelection() {
  _init_properties_navigation_kt__ocd2vo();
  return mostRecentNavSelection;
}
var mostRecentNavSelection;
function contractorOrHomeownerDestination(_this__u8e3s4, ifContractor, ifHomeowner) {
  _init_properties_navigation_kt__ocd2vo();
  return _this__u8e3s4.daj(get_loggedInAsContractor()) ? ifContractor : ifHomeowner;
}
function crowpaySideNav(_this__u8e3s4) {
  _init_properties_navigation_kt__ocd2vo();
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(true);
  var $this$col = view;
  $this$col.bb9(get_dp(0));
  shownDefaultFalse($this$col, ($this$shownDefaultFalse) => $this$shownDefaultFalse.daj(get_navExists($this$col)));
  applySafeInsets($this$col, VOID, false, false);
  space($this$col, minus(get_AppDimensions().yg1_1, get_rem(0.75)));
  var tmp = get_simpleHome(Companion_getInstance());
  crowpaySideNav$_anonymous_$navLink_luklqb($this$col, tmp, 'Home', VOID, VOID, crowpaySideNav$lambda);
  var tmp_0 = get_projects(Companion_getInstance());
  var tmp_1 = MemberRole_Employee_getInstance();
  crowpaySideNav$_anonymous_$contractorLink_6i8e29($this$col, tmp_0, 'Projects', tmp_1, VOID, crowpaySideNav$lambda_0);
  var tmp_2 = get_clients(Companion_getInstance());
  var tmp_3 = MemberRole_Manager_getInstance();
  crowpaySideNav$_anonymous_$contractorLink_6i8e29($this$col, tmp_2, 'Clients', tmp_3, VOID, crowpaySideNav$lambda_1);
  var tmp_4 = get_workList(Companion_getInstance());
  var tmp_5 = MemberRole_Employee_getInstance();
  crowpaySideNav$_anonymous_$contractorLink_6i8e29($this$col, tmp_4, 'Tasks', tmp_5, VOID, crowpaySideNav$lambda_2);
  var tmp_6 = get_messageBubble(Companion_getInstance());
  var tmp_7 = crowpaySideNav$lambda_3;
  crowpaySideNav$_anonymous_$navLink_luklqb($this$col, tmp_6, 'Messages', tmp_7, VOID, crowpaySideNav$lambda_4);
  var tmp_8 = get_finances(Companion_getInstance());
  var tmp_9 = crowpaySideNav$lambda_5;
  crowpaySideNav$_anonymous_$navLink_luklqb($this$col, tmp_8, 'Finances', tmp_9, VOID, crowpaySideNav$lambda_6);
  var tmp_10 = get_edit(Companion_getInstance());
  var tmp_11 = crowpaySideNav$lambda_7;
  crowpaySideNav$_anonymous_$navLink_luklqb($this$col, tmp_10, 'Dev Projects', tmp_11, VOID, crowpaySideNav$lambda_8);
  var isAdmin = remember(VOID, VOID, VOID, crowpaySideNav$lambda_9);
  var tmp_12 = get_barGraphReport(Companion_getInstance());
  var tmp_13 = ($this$navLink) => $this$navLink.daj(isAdmin);
  crowpaySideNav$_anonymous_$navLink_luklqb($this$col, tmp_12, 'Reports', tmp_13, VOID, crowpaySideNav$lambda_10);
  var tmp_14 = get_bank(Companion_getInstance());
  var tmp_15 = ($this$navLink) => $this$navLink.daj(isAdmin);
  crowpaySideNav$_anonymous_$navLink_luklqb($this$col, tmp_14, 'Admin Deposits', tmp_15, VOID, crowpaySideNav$lambda_11);
  var tmp_16 = get_expanding($this$col);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (Space())($this$col.pc());
  var tmp0_elvis_lhs_0 = $this$col.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? $this$col : tmp0_elvis_lhs_0;
  $this$col.gbb(p_0, view_0);
  $this$col.hbb(p_0, view_0);
  $this$col.lbb(tmp_16, view_0);
  var settingsOpen = Signal().hak(false);
  var tmp_17 = shownWhen($this$col, VOID, ($this$shownWhen) => $this$shownWhen.daj(settingsOpen));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())($this$col.pc());
  var tmp0_elvis_lhs_1 = $this$col.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? $this$col : tmp0_elvis_lhs_1;
  $this$col.gbb(p_1, view_1);
  view_1.zbm(true);
  view_1.bb9(get_rem_0(0));
  greySeparator(view_1);
  var tmp_18 = crowpaySideNav$slambda_0(settingsOpen);
  crowpaySideNav$_anonymous_$navLink_luklqb(view_1, null, 'Alerts', VOID, tmp_18, crowpaySideNav$lambda_12);
  var tmp_19 = MemberRole_Manager_getInstance();
  var tmp_20 = crowpaySideNav$slambda_2(settingsOpen);
  crowpaySideNav$_anonymous_$contractorLink_6i8e29(view_1, null, 'Specifications', tmp_19, tmp_20, crowpaySideNav$lambda_13);
  var tmp_21 = MemberRole_Manager_getInstance();
  var tmp_22 = crowpaySideNav$slambda_4(settingsOpen);
  crowpaySideNav$_anonymous_$contractorLink_6i8e29(view_1, null, 'Users', tmp_21, tmp_22, crowpaySideNav$lambda_14);
  $this$col.hbb(p_1, view_1);
  $this$col.lbb(tmp_17, view_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (Button())($this$col.pc());
  var tmp0_elvis_lhs_2 = $this$col.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? $this$col : tmp0_elvis_lhs_2;
  $this$col.gbb(p_2, view_2);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (RowOrCol())(view_2.pc());
  var tmp0_elvis_lhs_3 = view_2.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
  view_2.gbb(p_3, view_3);
  view_3.zbm(false);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (Space())(view_3.pc(), 0.3);
  var tmp0_elvis_lhs_4 = view_3.ebb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
  view_3.gbb(p_4, view_4);
  view_3.hbb(p_4, view_4);
  view_3.lbb(get_centered(view_3), icon(view_3, Companion_getInstance().wcf_1, 'settings'));
  var tmp_23 = get_centered(view_3);
  // Inline function 'com.crowpay.views.theming.subTitle' call
  var content = 'Settings';
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (TextView())(view_3.pc());
  var tmp0_elvis_lhs_5 = view_3.ebb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_3 : tmp0_elvis_lhs_5;
  view_3.gbb(p_5, view_5);
  view_5.lba(view_5.qb6_1.abf(SubtitleSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_24 = view_5.vb5_1;
  var tmp_25;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(content) === 0) {
    tmp_25 = '\xA0';
  } else {
    tmp_25 = content;
  }
  tmp_24.hbu(tmp_25);
  view_3.hbb(p_5, view_5);
  view_3.lbb(tmp_23, view_5);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (Space())(view_3.pc());
  var tmp0_elvis_lhs_6 = view_3.ebb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view_3 : tmp0_elvis_lhs_6;
  view_3.gbb(p_6, view_6);
  view_3.hbb(p_6, view_6);
  view_2.hbb(p_3, view_3);
  onClick(view_2, 'Toggle Settings', VOID, crowpaySideNav$slambda_6(settingsOpen));
  $this$col.hbb(p_2, view_2);
  var tmp_26 = $this$col.kbb(shownWhen($this$col, VOID, crowpaySideNav$lambda_15), $this$col.jbb(TestServerSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_7 = new (Frame())($this$col.pc());
  var tmp0_elvis_lhs_7 = $this$col.ebb_1;
  var p_7 = tmp0_elvis_lhs_7 == null ? $this$col : tmp0_elvis_lhs_7;
  $this$col.gbb(p_7, view_7);
  var tmp_27 = get_centered(view_7);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_8 = new (TextView())(view_7.pc());
  var tmp0_elvis_lhs_8 = view_7.ebb_1;
  var p_8 = tmp0_elvis_lhs_8 == null ? view_7 : tmp0_elvis_lhs_8;
  view_7.gbb(p_8, view_8);
  var tmp_28 = KMutableProperty0();
  var tmp_29 = TextView$_get_content_$ref_4pzcwl(view_8);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_28, tmp_29, TextView$_set_content_$ref_pketfb(view_8));
  reactiveScope(view_8, ($this$reactiveScope) => {
    var tmp;
    if (getDefaultServerBackend().equals(ApiOption_Production_getInstance())) {
      tmp = 'Using Test Server ' + $this$reactiveScope.daj(get_selectedApi()).a4_1;
    } else {
      tmp = 'Using Server ' + $this$reactiveScope.daj(get_selectedApi()).a4_1;
    }
    var tmp$ret$26 = tmp;
    this_0.set(tmp$ret$26);
    return Unit_instance;
  });
  view_7.hbb(p_8, view_8);
  view_7.lbb(tmp_27, view_8);
  $this$col.hbb(p_7, view_7);
  $this$col.lbb(tmp_26, view_7);
  space($this$col, minus(get_AppDimensions().yg1_1, get_rem(1.25)));
  _this__u8e3s4.hbb(p, view);
  return view;
}
function crowpayBottomNav(_this__u8e3s4) {
  _init_properties_navigation_kt__ocd2vo();
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(false);
  view.bb9(get_AppDimensions().lg2_1);
  view.gba(get_AppDimensions().lg2_1);
  applySafeInsets(view, false, false, false);
  var tmp = weight(view, 0.9);
  var tmp_0 = get_simpleHome(Companion_getInstance());
  view.lbb(tmp, crowpayBottomNav$navLink(view, tmp_0, 'Home', VOID, VOID, VOID, crowpayBottomNav$lambda));
  var tmp_1 = weight(view, 1.0);
  var tmp_2 = get_projects(Companion_getInstance());
  view.lbb(tmp_1, crowpayBottomNav$contractorLink(view, tmp_2, 'Projects', VOID, crowpayBottomNav$lambda_0));
  var tmp_3 = weight(view, 0.8);
  var tmp_4 = get_notificationBellOutline(Companion_getInstance());
  var tmp_5 = crowpayBottomNav$lambda_1;
  view.lbb(tmp_3, crowpayBottomNav$navLink(view, tmp_4, 'Alerts', VOID, VOID, tmp_5, crowpayBottomNav$lambda_2));
  var tmp_6 = weight(view, 1.0);
  var tmp_7 = get_messageBubble(Companion_getInstance());
  var tmp_8 = crowpayBottomNav$lambda_3;
  view.lbb(tmp_6, crowpayBottomNav$navLink(view, tmp_7, 'Messages', tmp_8, VOID, VOID, crowpayBottomNav$lambda_4));
  var tmp_9 = view.kbb(weight(view, 0.9), view.jbb(UnselectedSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.menuButton' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (MenuButton())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.gba(get_dp(0));
  view_0.bb9(get_dp(0));
  view_0.dc4(Companion_getInstance_0().dcr_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.gbb(p_1, view_1);
  view_1.zbm(true);
  view_1.bb9(get_AppDimensions().og2_1);
  view_1.lbb(get_centered(view_1), icon(view_1, Companion_getInstance().ucf_1, 'menu'));
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (TextView())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.gbb(p_2, view_2);
  view_2.lba(view_2.qb6_1.abf(BodySemantic_getInstance().abf(BoldSemantic_getInstance())));
  view_2.dbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_10 = view_2.vb5_1;
  var tmp_11;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength('More') === 0) {
    tmp_11 = '\xA0';
  } else {
    tmp_11 = 'More';
  }
  tmp_10.hbu(tmp_11);
  view_1.hbb(p_2, view_2);
  view_0.hbb(p_1, view_1);
  view_0.gc4(crowpayBottomNav$lambda_5);
  view.hbb(p_0, view_0);
  view.lbb(tmp_9, view_0);
  _this__u8e3s4.hbb(p, view);
  return view;
}
function crowpaySideNav$_anonymous_$navLink_luklqb(_this__u8e3s4, icon_0, text, exists, onNavigate, destination) {
  exists = exists === VOID ? null : exists;
  onNavigate = onNavigate === VOID ? null : onNavigate;
  // Inline function 'com.lightningkite.kiteui.views.direct.link' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Link())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  if (exists == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    shownDefaultFalse(view, exists);
  }
  view.vbw(crowpaySideNav$_anonymous_$navLink$slambda_3sloib_0(onNavigate, text));
  dynamicTheme(view, ($this$dynamicTheme) => text === $this$dynamicTheme.daj(get_mostRecentNavSelection()) ? SelectedSemantic_getInstance() : UnselectedSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.zbm(false);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (Space())(view_0.pc(), 0.3);
  var tmp0_elvis_lhs_1 = view_0.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.gbb(p_1, view_1);
  view_0.hbb(p_1, view_1);
  if (icon_0 == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    view_0.lbb(get_centered(view_0), icon(view_0, resize(icon_0, get_rem(1.5)), text));
  }
  var tmp = get_centered(view_0);
  // Inline function 'com.crowpay.views.theming.subTitle' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (TextView())(view_0.pc());
  var tmp0_elvis_lhs_2 = view_0.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
  view_0.gbb(p_2, view_2);
  view_2.lba(view_2.qb6_1.abf(SubtitleSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_0 = view_2.vb5_1;
  var tmp_1;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(text) === 0) {
    tmp_1 = '\xA0';
  } else {
    tmp_1 = text;
  }
  tmp_0.hbu(tmp_1);
  view_0.hbb(p_2, view_2);
  view_0.lbb(tmp, view_2);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (Space())(view_0.pc());
  var tmp0_elvis_lhs_3 = view_0.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_0 : tmp0_elvis_lhs_3;
  view_0.gbb(p_3, view_3);
  view_0.hbb(p_3, view_3);
  view.hbb(p_0, view_0);
  var tmp_2 = KMutableProperty0();
  var tmp_3 = Link$_get_to_$ref_jq7esp(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('to', 0, tmp_2, tmp_3, Link$_set_to_$ref_i9gu5x(view));
  reactiveScope(view, ($this$reactiveScope) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    var tmp$ret$21 = destination($this$reactiveScope);
    this_0.set(tmp$ret$21);
    return Unit_instance;
  });
  _this__u8e3s4.hbb(p, view);
  return view;
}
function crowpaySideNav$_anonymous_$contractorLink_6i8e29(_this__u8e3s4, icon, text, roleRequirement, onNavigate, destination) {
  onNavigate = onNavigate === VOID ? null : onNavigate;
  return crowpaySideNav$_anonymous_$navLink_luklqb(_this__u8e3s4, icon, text, ($this$navLink) => {
    var tmp;
    if ($this$navLink.daj(get_loggedInAsContractor())) {
      var tmp0_safe_receiver = $this$navLink.daj(get_rawSession());
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : $this$navLink.daj(tmp0_safe_receiver.rfw_1);
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.k88_1;
      var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.h8c_1;
      var tmp_0;
      if (tmp3_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_0 = tmp3_safe_receiver.d4(roleRequirement) >= 0;
      }
      var tmp4_elvis_lhs = tmp_0;
      tmp = tmp4_elvis_lhs == null ? false : tmp4_elvis_lhs;
    } else {
      tmp = false;
    }
    return tmp;
  }, onNavigate, destination);
}
function crowpayBottomNav$navLink(_this__u8e3s4, icon_0, text, exists, onNavigate, additionalSetup, destination) {
  exists = exists === VOID ? null : exists;
  onNavigate = onNavigate === VOID ? null : onNavigate;
  var tmp;
  if (additionalSetup === VOID) {
    tmp = crowpayBottomNav$navLink$lambda;
  } else {
    tmp = additionalSetup;
  }
  additionalSetup = tmp;
  // Inline function 'com.lightningkite.kiteui.views.direct.link' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Link())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.gba(get_dp(0));
  view.bb9(get_dp(0));
  if (exists == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    shownDefaultFalse(view, exists);
  }
  view.vbw(crowpayBottomNav$navLink$slambda_0(onNavigate, text));
  dynamicTheme(view, ($this$dynamicTheme) => text === $this$dynamicTheme.daj(get_mostRecentNavSelection()) ? SelectedSemantic_getInstance() : UnselectedSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.zbm(true);
  view_0.bb9(get_AppDimensions().og2_1);
  if (icon_0 == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    view_0.lbb(get_centered(view_0), icon(view_0, resize(icon_0, get_rem(1.5)), text));
  }
  view_0.lbb(get_centered(view_0), bodyBold(view_0, text));
  view.hbb(p_0, view_0);
  var tmp_0 = KMutableProperty0();
  var tmp_1 = Link$_get_to_$ref_jq7esp_0(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('to', 0, tmp_0, tmp_1, Link$_set_to_$ref_i9gu5x_0(view));
  reactiveScope(view, ($this$reactiveScope) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    var tmp$ret$9 = destination($this$reactiveScope);
    this_0.set(tmp$ret$9);
    return Unit_instance;
  });
  additionalSetup(view);
  _this__u8e3s4.hbb(p, view);
  return view;
}
function crowpayBottomNav$contractorLink(_this__u8e3s4, icon, text, onNavigate, destination) {
  onNavigate = onNavigate === VOID ? null : onNavigate;
  var tmp = crowpayBottomNav$contractorLink$lambda;
  return crowpayBottomNav$navLink(_this__u8e3s4, icon, text, tmp, onNavigate, crowpayBottomNav$contractorLink$lambda_0, destination);
}
function crowpayBottomNav$_anonymous_$_anonymous_$_anonymous_$_anonymous_$menuLink_u442ky(_this__u8e3s4, icon_0, name, exists, to) {
  exists = exists === VOID ? null : exists;
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var tmp = _this__u8e3s4.jbb(ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.link' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Link())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  if (!(icon_0 == null)) {
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_0 = view.ebb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.gbb(p_0, view_0);
    view_0.zbm(false);
    view_0.lbb(get_centered(view_0), icon(view_0, resize(icon_0, get_rem(1.5)), name));
    view_0.lbb(get_centered(view_0), bodyBold(view_0, name));
    view.hbb(p_0, view_0);
  } else
    body(view, name);
  if (exists == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var tmp_0 = KMutableProperty0();
    var tmp_1 = Link$_get_shown_$ref_4nyipx(view);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('shown', 0, tmp_0, tmp_1, Link$_set_shown_$ref_omvxon(view));
    var actionToCalculate = exists;
    reactiveScope(view, ($this$reactiveScope) => {
      this_0.set(actionToCalculate($this$reactiveScope));
      return Unit_instance;
    });
  }
  view.vbw(crowpayBottomNav$_anonymous_$_anonymous_$_anonymous_$_anonymous_$menuLink$slambda_gsf7u0_0(name, view));
  dynamicTheme(view, ($this$dynamicTheme) => name === $this$dynamicTheme.daj(get_mostRecentNavSelection()) ? SelectedSemantic_getInstance() : UnselectedSemantic_getInstance());
  var tmp_2 = KMutableProperty0();
  var tmp_3 = Link$_get_to_$ref_jq7esp_1(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('to', 0, tmp_2, tmp_3, Link$_set_to_$ref_i9gu5x_1(view));
  var actionToCalculate_0 = to;
  reactiveScope(view, ($this$reactiveScope) => {
    this_1.set(actionToCalculate_0($this$reactiveScope));
    return Unit_instance;
  });
  _this__u8e3s4.hbb(p, view);
  return _this__u8e3s4.lbb(tmp, view);
}
function crowpayBottomNav$_anonymous_$_anonymous_$_anonymous_$_anonymous_$conMenuLink_897hge(_this__u8e3s4, icon, name, roleRequirement, to) {
  return crowpayBottomNav$_anonymous_$_anonymous_$_anonymous_$_anonymous_$menuLink_u442ky(_this__u8e3s4, icon, name, ($this$menuLink) => {
    var tmp;
    if ($this$menuLink.daj(get_loggedInAsContractor())) {
      var tmp0_safe_receiver = $this$menuLink.daj(get_rawSession());
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : $this$menuLink.daj(tmp0_safe_receiver.rfw_1);
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.k88_1;
      var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.h8c_1;
      var tmp_0;
      if (tmp3_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_0 = tmp3_safe_receiver.d4(roleRequirement) >= 0;
      }
      var tmp4_elvis_lhs = tmp_0;
      tmp = tmp4_elvis_lhs == null ? false : tmp4_elvis_lhs;
    } else {
      tmp = false;
    }
    return tmp;
  }, to);
}
function crowpaySideNav$lambda($this$navLink) {
  _init_properties_navigation_kt__ocd2vo();
  var tmp = crowpaySideNav$lambda$lambda;
  return contractorOrHomeownerDestination($this$navLink, tmp, crowpaySideNav$lambda$lambda_0);
}
function crowpaySideNav$lambda$lambda() {
  _init_properties_navigation_kt__ocd2vo();
  return new (ContractorDashboard())();
}
function crowpaySideNav$lambda$lambda_0() {
  _init_properties_navigation_kt__ocd2vo();
  return new (ClientDashboard())();
}
function crowpaySideNav$lambda_0($this$contractorLink) {
  _init_properties_navigation_kt__ocd2vo();
  var tmp = crowpaySideNav$lambda$lambda_1;
  return contractorOrHomeownerDestination($this$contractorLink, tmp, crowpaySideNav$lambda$lambda_2);
}
function crowpaySideNav$lambda$lambda_1() {
  _init_properties_navigation_kt__ocd2vo();
  return new (ContractorProjects())();
}
function crowpaySideNav$lambda$lambda_2() {
  _init_properties_navigation_kt__ocd2vo();
  return new (ClientProjects())();
}
function crowpaySideNav$lambda_1($this$contractorLink) {
  _init_properties_navigation_kt__ocd2vo();
  return crowpaySideNav$lambda$lambda_3;
}
function crowpaySideNav$lambda$lambda_3() {
  _init_properties_navigation_kt__ocd2vo();
  return new (ContractorClients())();
}
function crowpaySideNav$lambda_2($this$contractorLink) {
  _init_properties_navigation_kt__ocd2vo();
  var tmp = crowpaySideNav$lambda$lambda_4;
  return contractorOrHomeownerDestination($this$contractorLink, tmp, crowpaySideNav$lambda$lambda_5);
}
function crowpaySideNav$lambda$lambda_4() {
  _init_properties_navigation_kt__ocd2vo();
  return new (ContractorWorkLists())();
}
function crowpaySideNav$lambda$lambda_5() {
  _init_properties_navigation_kt__ocd2vo();
  return new (ClientWorkLists())();
}
function crowpaySideNav$lambda_3($this$navLink) {
  _init_properties_navigation_kt__ocd2vo();
  var tmp = setOf([null, MemberRole_Admin_getInstance(), MemberRole_Manager_getInstance()]);
  var tmp0_safe_receiver = $this$navLink.daj(get_rawSession());
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : $this$navLink.daj(tmp0_safe_receiver.rfw_1);
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.k88_1;
  return tmp.t1(tmp2_safe_receiver == null ? null : tmp2_safe_receiver.h8c_1);
}
function crowpaySideNav$lambda_4($this$navLink) {
  _init_properties_navigation_kt__ocd2vo();
  var lens = $this$navLink.daj(get_loggedInAsContractor()) ? ProjectLens_Contractor_getInstance() : ProjectLens_Customer_getInstance();
  var tmp0_safe_receiver = $this$navLink.daj(get_rawSession());
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : $this$navLink.daj(tmp0_safe_receiver.sfw_1);
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : singleOrNull(tmp1_safe_receiver);
  var tmp;
  if (tmp2_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var it = tmp2_safe_receiver;
    tmp = () => new (ProjectMessageThread())(it.v7a_1, lens);
  }
  var tmp3_elvis_lhs = tmp;
  var tmp_0;
  if (tmp3_elvis_lhs == null) {
    tmp_0 = () => new (MessagingScreen())(lens);
  } else {
    tmp_0 = tmp3_elvis_lhs;
  }
  return tmp_0;
}
function crowpaySideNav$lambda_5($this$navLink) {
  _init_properties_navigation_kt__ocd2vo();
  var tmp = setOf([null, MemberRole_Admin_getInstance(), MemberRole_Manager_getInstance()]);
  var tmp0_safe_receiver = $this$navLink.daj(get_rawSession());
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : $this$navLink.daj(tmp0_safe_receiver.rfw_1);
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.k88_1;
  return tmp.t1(tmp2_safe_receiver == null ? null : tmp2_safe_receiver.h8c_1);
}
function crowpaySideNav$lambda_6($this$navLink) {
  _init_properties_navigation_kt__ocd2vo();
  var tmp = crowpaySideNav$lambda$lambda_6;
  return contractorOrHomeownerDestination($this$navLink, tmp, crowpaySideNav$lambda$lambda_7);
}
function crowpaySideNav$lambda$lambda_6() {
  _init_properties_navigation_kt__ocd2vo();
  return new (ContractorPayments())();
}
function crowpaySideNav$lambda$lambda_7() {
  _init_properties_navigation_kt__ocd2vo();
  return new (ClientPayments())();
}
function crowpaySideNav$lambda_7($this$navLink) {
  _init_properties_navigation_kt__ocd2vo();
  return Companion_getInstance_1().efx_1.t1($this$navLink.daj(get_selectedApi()));
}
function crowpaySideNav$lambda_8($this$navLink) {
  _init_properties_navigation_kt__ocd2vo();
  return crowpaySideNav$lambda$lambda_8;
}
function crowpaySideNav$lambda$lambda_8() {
  _init_properties_navigation_kt__ocd2vo();
  return new (SelectDevProjectScreen())();
}
function crowpaySideNav$lambda_9($this$remember) {
  _init_properties_navigation_kt__ocd2vo();
  var tmp0_safe_receiver = $this$remember.daj(get_rawSession());
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : $this$remember.daj(tmp0_safe_receiver.rfw_1);
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = tmp1_safe_receiver.m88_1.d4(UserRole_Admin_getInstance()) >= 0;
  }
  return tmp === true;
}
function crowpaySideNav$lambda_10($this$navLink) {
  _init_properties_navigation_kt__ocd2vo();
  return crowpaySideNav$lambda$lambda_9;
}
function crowpaySideNav$lambda$lambda_9() {
  _init_properties_navigation_kt__ocd2vo();
  return new (AdminReportingPage())();
}
function crowpaySideNav$lambda_11($this$navLink) {
  _init_properties_navigation_kt__ocd2vo();
  return crowpaySideNav$lambda$lambda_10;
}
function crowpaySideNav$lambda$lambda_10() {
  _init_properties_navigation_kt__ocd2vo();
  return new (AdminExternalDepositPage())();
}
var crowpaySideNav$slambdaClass;
function crowpaySideNav$slambda() {
  if (crowpaySideNav$slambdaClass === VOID) {
    class $ {
      constructor($settingsOpen) {
        this.pgh_1 = $settingsOpen;
      }
      uao($completion) {
        this.pgh_1.oam(false);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    crowpaySideNav$slambdaClass = $;
  }
  return crowpaySideNav$slambdaClass;
}
function crowpaySideNav$slambda_0($settingsOpen) {
  var i = new (crowpaySideNav$slambda())($settingsOpen);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function crowpaySideNav$lambda_12($this$navLink) {
  _init_properties_navigation_kt__ocd2vo();
  var tmp = crowpaySideNav$lambda$lambda_11;
  return contractorOrHomeownerDestination($this$navLink, tmp, crowpaySideNav$lambda$lambda_12);
}
function crowpaySideNav$lambda$lambda_11() {
  _init_properties_navigation_kt__ocd2vo();
  return new (ContractorNotificationSettings())();
}
function crowpaySideNav$lambda$lambda_12() {
  _init_properties_navigation_kt__ocd2vo();
  return new (ClientNotificationSettings())();
}
var crowpaySideNav$slambdaClass_0;
function crowpaySideNav$slambda_1() {
  if (crowpaySideNav$slambdaClass_0 === VOID) {
    class $ {
      constructor($settingsOpen) {
        this.qgh_1 = $settingsOpen;
      }
      uao($completion) {
        this.qgh_1.oam(false);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    crowpaySideNav$slambdaClass_0 = $;
  }
  return crowpaySideNav$slambdaClass_0;
}
function crowpaySideNav$slambda_2($settingsOpen) {
  var i = new (crowpaySideNav$slambda_1())($settingsOpen);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function crowpaySideNav$lambda_13($this$contractorLink) {
  _init_properties_navigation_kt__ocd2vo();
  return crowpaySideNav$lambda$lambda_13;
}
function crowpaySideNav$lambda$lambda_13() {
  _init_properties_navigation_kt__ocd2vo();
  return new (Specifications())();
}
var crowpaySideNav$slambdaClass_1;
function crowpaySideNav$slambda_3() {
  if (crowpaySideNav$slambdaClass_1 === VOID) {
    class $ {
      constructor($settingsOpen) {
        this.rgh_1 = $settingsOpen;
      }
      uao($completion) {
        this.rgh_1.oam(false);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    crowpaySideNav$slambdaClass_1 = $;
  }
  return crowpaySideNav$slambdaClass_1;
}
function crowpaySideNav$slambda_4($settingsOpen) {
  var i = new (crowpaySideNav$slambda_3())($settingsOpen);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function crowpaySideNav$lambda_14($this$contractorLink) {
  _init_properties_navigation_kt__ocd2vo();
  return crowpaySideNav$lambda$lambda_14;
}
function crowpaySideNav$lambda$lambda_14() {
  _init_properties_navigation_kt__ocd2vo();
  return new (ManageContractorUsers())();
}
var crowpaySideNav$slambdaClass_2;
function crowpaySideNav$slambda_5() {
  if (crowpaySideNav$slambdaClass_2 === VOID) {
    class $ {
      constructor($settingsOpen) {
        this.sgh_1 = $settingsOpen;
      }
      uao($completion) {
        toggle(this.sgh_1);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    crowpaySideNav$slambdaClass_2 = $;
  }
  return crowpaySideNav$slambdaClass_2;
}
function crowpaySideNav$slambda_6($settingsOpen) {
  var i = new (crowpaySideNav$slambda_5())($settingsOpen);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function crowpaySideNav$lambda_15($this$shownWhen) {
  _init_properties_navigation_kt__ocd2vo();
  return !$this$shownWhen.daj(get_selectedApi()).equals(getDefaultServerBackend());
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function crowpayBottomNav$lambda($this$navLink) {
  _init_properties_navigation_kt__ocd2vo();
  var tmp = crowpayBottomNav$lambda$lambda;
  return contractorOrHomeownerDestination($this$navLink, tmp, crowpayBottomNav$lambda$lambda_0);
}
function crowpayBottomNav$lambda$lambda() {
  _init_properties_navigation_kt__ocd2vo();
  return new (ContractorDashboard())();
}
function crowpayBottomNav$lambda$lambda_0() {
  _init_properties_navigation_kt__ocd2vo();
  return new (ClientDashboard())();
}
function crowpayBottomNav$lambda_0($this$contractorLink) {
  _init_properties_navigation_kt__ocd2vo();
  var tmp = crowpayBottomNav$lambda$lambda_1;
  return contractorOrHomeownerDestination($this$contractorLink, tmp, crowpayBottomNav$lambda$lambda_2);
}
function crowpayBottomNav$lambda$lambda_1() {
  _init_properties_navigation_kt__ocd2vo();
  return new (ContractorProjects())();
}
function crowpayBottomNav$lambda$lambda_2() {
  _init_properties_navigation_kt__ocd2vo();
  return new (ClientProjects())();
}
function crowpayBottomNav$lambda_1($this$navLink) {
  _init_properties_navigation_kt__ocd2vo();
  var tmp = get_atTop($this$navLink);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())($this$navLink.pc());
  var tmp0_elvis_lhs = $this$navLink.ebb_1;
  var p = tmp0_elvis_lhs == null ? $this$navLink : tmp0_elvis_lhs;
  $this$navLink.gbb(p, view);
  view.zbm(false);
  var tmp_0 = weight(view, 0.5);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (Space())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view.hbb(p_0, view_0);
  view.lbb(tmp_0, view_0);
  var tmp_1 = weight(view, 3.0);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (Frame())(view.pc());
  var tmp0_elvis_lhs_1 = view.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
  view.gbb(p_1, view_1);
  view_1.lbb(get_atTopCenter(view_1), UserNotifications_getInstance().kgg(view_1));
  view.hbb(p_1, view_1);
  view.lbb(tmp_1, view_1);
  $this$navLink.hbb(p, view);
  $this$navLink.lbb(tmp, view);
  return Unit_instance;
}
function crowpayBottomNav$lambda_2($this$navLink) {
  _init_properties_navigation_kt__ocd2vo();
  return crowpayBottomNav$lambda$lambda_3;
}
function crowpayBottomNav$lambda$lambda_3() {
  _init_properties_navigation_kt__ocd2vo();
  return UserNotifications_getInstance();
}
function crowpayBottomNav$lambda_3($this$navLink) {
  _init_properties_navigation_kt__ocd2vo();
  var tmp = setOf([null, MemberRole_Admin_getInstance(), MemberRole_Manager_getInstance()]);
  var tmp0_safe_receiver = $this$navLink.daj(get_rawSession());
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : $this$navLink.daj(tmp0_safe_receiver.rfw_1);
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.k88_1;
  return tmp.t1(tmp2_safe_receiver == null ? null : tmp2_safe_receiver.h8c_1);
}
function crowpayBottomNav$lambda_4($this$navLink) {
  _init_properties_navigation_kt__ocd2vo();
  var lens = $this$navLink.daj(get_loggedInAsContractor()) ? ProjectLens_Contractor_getInstance() : ProjectLens_Customer_getInstance();
  var tmp0_safe_receiver = $this$navLink.daj(get_rawSession());
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : $this$navLink.daj(tmp0_safe_receiver.sfw_1);
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : singleOrNull(tmp1_safe_receiver);
  var tmp;
  if (tmp2_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var it = tmp2_safe_receiver;
    tmp = () => new (ProjectMessageThread())(it.v7a_1, lens);
  }
  var tmp3_elvis_lhs = tmp;
  var tmp_0;
  if (tmp3_elvis_lhs == null) {
    tmp_0 = () => new (MessagingScreen())(lens);
  } else {
    tmp_0 = tmp3_elvis_lhs;
  }
  return tmp_0;
}
function crowpayBottomNav$lambda_5($this$opensMenu) {
  _init_properties_navigation_kt__ocd2vo();
  var settingsOpen = Signal().hak(false);
  var tmp = $this$opensMenu.kbb($this$opensMenu.kbb(sizeConstraints($this$opensMenu, VOID, VOID, VOID, VOID, VOID, get_rem_0(8)), $this$opensMenu.jbb((new (Set())(get_appTheme())).abf(MobileNavSemantic_getInstance()).abf(NavSemantic_getInstance()))), get_unpadded($this$opensMenu));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())($this$opensMenu.pc());
  var tmp0_elvis_lhs = $this$opensMenu.ebb_1;
  var p = tmp0_elvis_lhs == null ? $this$opensMenu : tmp0_elvis_lhs;
  $this$opensMenu.gbb(p, view);
  view.zbm(true);
  view.bb9(get_px(0));
  var tmp_0 = get_clients(Companion_getInstance());
  var tmp_1 = MemberRole_Manager_getInstance();
  crowpayBottomNav$_anonymous_$_anonymous_$_anonymous_$_anonymous_$conMenuLink_897hge(view, tmp_0, 'Clients', tmp_1, crowpayBottomNav$lambda$lambda_4);
  greySeparator(view);
  var tmp_2 = get_workList(Companion_getInstance());
  var tmp_3 = MemberRole_Employee_getInstance();
  crowpayBottomNav$_anonymous_$_anonymous_$_anonymous_$_anonymous_$conMenuLink_897hge(view, tmp_2, 'Tasks', tmp_3, crowpayBottomNav$lambda$lambda_5);
  greySeparator(view);
  var tmp_4 = get_finances(Companion_getInstance());
  var tmp_5 = crowpayBottomNav$lambda$lambda_6;
  crowpayBottomNav$_anonymous_$_anonymous_$_anonymous_$_anonymous_$menuLink_u442ky(view, tmp_4, 'Finances', tmp_5, crowpayBottomNav$lambda$lambda_7);
  greySeparator(view);
  var tmp_6 = shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.daj(settingsOpen));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.zbm(true);
  view_0.bb9(get_AppDimensions().og2_1);
  crowpayBottomNav$_anonymous_$_anonymous_$_anonymous_$_anonymous_$menuLink_u442ky(view_0, null, 'Alerts', VOID, crowpayBottomNav$lambda$lambda_8);
  var tmp_7 = MemberRole_Manager_getInstance();
  crowpayBottomNav$_anonymous_$_anonymous_$_anonymous_$_anonymous_$conMenuLink_897hge(view_0, null, 'Specifications', tmp_7, crowpayBottomNav$lambda$lambda_9);
  var tmp_8 = MemberRole_Manager_getInstance();
  crowpayBottomNav$_anonymous_$_anonymous_$_anonymous_$_anonymous_$conMenuLink_897hge(view_0, null, 'Users', tmp_8, crowpayBottomNav$lambda$lambda_10);
  view.hbb(p_0, view_0);
  view.lbb(tmp_6, view_0);
  var tmp_9 = view.jbb(ButtonSemantic_getInstance().abf(UnselectedSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (Button())(view.pc());
  var tmp0_elvis_lhs_1 = view.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
  view.gbb(p_1, view_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (RowOrCol())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.gbb(p_2, view_2);
  view_2.zbm(false);
  view_2.lbb(get_centered(view_2), icon(view_2, resize(Companion_getInstance().wcf_1, get_rem(1.5)), 'settings'));
  view_2.lbb(get_centered(view_2), bodyBold(view_2, 'Settings'));
  view_1.hbb(p_2, view_2);
  onClick(view_1, VOID, VOID, crowpayBottomNav$lambda$slambda_0(settingsOpen));
  view.hbb(p_1, view_1);
  view.lbb(tmp_9, view_1);
  $this$opensMenu.hbb(p, view);
  $this$opensMenu.lbb(tmp, view);
  return Unit_instance;
}
function crowpayBottomNav$lambda$lambda_4($this$conMenuLink) {
  _init_properties_navigation_kt__ocd2vo();
  return crowpayBottomNav$lambda$lambda$lambda;
}
function crowpayBottomNav$lambda$lambda$lambda() {
  _init_properties_navigation_kt__ocd2vo();
  return new (ContractorClients())();
}
function crowpayBottomNav$lambda$lambda_5($this$conMenuLink) {
  _init_properties_navigation_kt__ocd2vo();
  var tmp = crowpayBottomNav$lambda$lambda$lambda_0;
  return contractorOrHomeownerDestination($this$conMenuLink, tmp, crowpayBottomNav$lambda$lambda$lambda_1);
}
function crowpayBottomNav$lambda$lambda$lambda_0() {
  _init_properties_navigation_kt__ocd2vo();
  return new (ContractorWorkLists())();
}
function crowpayBottomNav$lambda$lambda$lambda_1() {
  _init_properties_navigation_kt__ocd2vo();
  return new (ClientWorkLists())();
}
function crowpayBottomNav$lambda$lambda_6($this$menuLink) {
  _init_properties_navigation_kt__ocd2vo();
  var tmp = setOf([null, MemberRole_Admin_getInstance(), MemberRole_Manager_getInstance()]);
  var tmp0_safe_receiver = $this$menuLink.daj(get_rawSession());
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : $this$menuLink.daj(tmp0_safe_receiver.rfw_1);
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.k88_1;
  return tmp.t1(tmp2_safe_receiver == null ? null : tmp2_safe_receiver.h8c_1);
}
function crowpayBottomNav$lambda$lambda_7($this$menuLink) {
  _init_properties_navigation_kt__ocd2vo();
  var tmp = crowpayBottomNav$lambda$lambda$lambda_2;
  return contractorOrHomeownerDestination($this$menuLink, tmp, crowpayBottomNav$lambda$lambda$lambda_3);
}
function crowpayBottomNav$lambda$lambda$lambda_2() {
  _init_properties_navigation_kt__ocd2vo();
  return new (ContractorPayments())();
}
function crowpayBottomNav$lambda$lambda$lambda_3() {
  _init_properties_navigation_kt__ocd2vo();
  return new (ClientPayments())();
}
function crowpayBottomNav$lambda$lambda_8($this$menuLink) {
  _init_properties_navigation_kt__ocd2vo();
  var tmp = crowpayBottomNav$lambda$lambda$lambda_4;
  return contractorOrHomeownerDestination($this$menuLink, tmp, crowpayBottomNav$lambda$lambda$lambda_5);
}
function crowpayBottomNav$lambda$lambda$lambda_4() {
  _init_properties_navigation_kt__ocd2vo();
  return new (ContractorNotificationSettings())();
}
function crowpayBottomNav$lambda$lambda$lambda_5() {
  _init_properties_navigation_kt__ocd2vo();
  return new (ClientNotificationSettings())();
}
function crowpayBottomNav$lambda$lambda_9($this$conMenuLink) {
  _init_properties_navigation_kt__ocd2vo();
  return crowpayBottomNav$lambda$lambda$lambda_6;
}
function crowpayBottomNav$lambda$lambda$lambda_6() {
  _init_properties_navigation_kt__ocd2vo();
  return new (Specifications())();
}
function crowpayBottomNav$lambda$lambda_10($this$conMenuLink) {
  _init_properties_navigation_kt__ocd2vo();
  return crowpayBottomNav$lambda$lambda$lambda_7;
}
function crowpayBottomNav$lambda$lambda$lambda_7() {
  _init_properties_navigation_kt__ocd2vo();
  return new (ManageContractorUsers())();
}
var crowpayBottomNav$lambda$slambdaClass;
function crowpayBottomNav$lambda$slambda() {
  if (crowpayBottomNav$lambda$slambdaClass === VOID) {
    class $ {
      constructor($settingsOpen) {
        this.tgh_1 = $settingsOpen;
      }
      uao($completion) {
        toggle(this.tgh_1);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    crowpayBottomNav$lambda$slambdaClass = $;
  }
  return crowpayBottomNav$lambda$slambdaClass;
}
function crowpayBottomNav$lambda$slambda_0($settingsOpen) {
  var i = new (crowpayBottomNav$lambda$slambda())($settingsOpen);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8($this, $completion) {
  var tmp0_safe_receiver = $this.ugh_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    var tmp = tmp0_safe_receiver($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  get_mostRecentNavSelection().oam($this.vgh_1);
  return Unit_instance;
}
var crowpaySideNav$_anonymous_$navLink$slambda_3sloibClass;
function crowpaySideNav$_anonymous_$navLink$slambda_3sloib() {
  if (crowpaySideNav$_anonymous_$navLink$slambda_3sloibClass === VOID) {
    class $ {
      constructor($onNavigate, $text) {
        this.ugh_1 = $onNavigate;
        this.vgh_1 = $text;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    crowpaySideNav$_anonymous_$navLink$slambda_3sloibClass = $;
  }
  return crowpaySideNav$_anonymous_$navLink$slambda_3sloibClass;
}
function crowpaySideNav$_anonymous_$navLink$slambda_3sloib_0($onNavigate, $text) {
  var i = new (crowpaySideNav$_anonymous_$navLink$slambda_3sloib())($onNavigate, $text);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function Link$_get_to_$ref_jq7esp(p0) {
  return () => p0.zbv_1;
}
function Link$_set_to_$ref_i9gu5x(p0) {
  return (_this__u8e3s4) => {
    p0.kbw(_this__u8e3s4);
    return Unit_instance;
  };
}
function crowpayBottomNav$navLink$lambda(_this__u8e3s4) {
  _init_properties_navigation_kt__ocd2vo();
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var tmp0_safe_receiver = $this.wgh_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    var tmp = tmp0_safe_receiver($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  get_mostRecentNavSelection().oam($this.xgh_1);
  return Unit_instance;
}
var crowpayBottomNav$navLink$slambdaClass;
function crowpayBottomNav$navLink$slambda() {
  if (crowpayBottomNav$navLink$slambdaClass === VOID) {
    class $ {
      constructor($onNavigate, $text) {
        this.wgh_1 = $onNavigate;
        this.xgh_1 = $text;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    crowpayBottomNav$navLink$slambdaClass = $;
  }
  return crowpayBottomNav$navLink$slambdaClass;
}
function crowpayBottomNav$navLink$slambda_0($onNavigate, $text) {
  var i = new (crowpayBottomNav$navLink$slambda())($onNavigate, $text);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function Link$_get_to_$ref_jq7esp_0(p0) {
  return () => p0.zbv_1;
}
function Link$_set_to_$ref_i9gu5x_0(p0) {
  return (_this__u8e3s4) => {
    p0.kbw(_this__u8e3s4);
    return Unit_instance;
  };
}
function crowpayBottomNav$contractorLink$lambda($this$navLink) {
  _init_properties_navigation_kt__ocd2vo();
  return $this$navLink.daj(get_loggedInAsContractor());
}
function crowpayBottomNav$contractorLink$lambda_0($this$navLink) {
  _init_properties_navigation_kt__ocd2vo();
  return Unit_instance;
}
function Link$_get_shown_$ref_4nyipx(p0) {
  return () => p0.yb8();
}
function Link$_set_shown_$ref_omvxon(p0) {
  return (_this__u8e3s4) => {
    p0.jb7(_this__u8e3s4);
    return Unit_instance;
  };
}
var crowpayBottomNav$_anonymous_$_anonymous_$_anonymous_$_anonymous_$menuLink$slambda_gsf7u0Class;
function crowpayBottomNav$_anonymous_$_anonymous_$_anonymous_$_anonymous_$menuLink$slambda_gsf7u0() {
  if (crowpayBottomNav$_anonymous_$_anonymous_$_anonymous_$_anonymous_$menuLink$slambda_gsf7u0Class === VOID) {
    class $ {
      constructor($name, $$this$link) {
        this.ygh_1 = $name;
        this.zgh_1 = $$this$link;
      }
      uao($completion) {
        get_mostRecentNavSelection().oam(this.ygh_1);
        closePopovers(this.zgh_1);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    crowpayBottomNav$_anonymous_$_anonymous_$_anonymous_$_anonymous_$menuLink$slambda_gsf7u0Class = $;
  }
  return crowpayBottomNav$_anonymous_$_anonymous_$_anonymous_$_anonymous_$menuLink$slambda_gsf7u0Class;
}
function crowpayBottomNav$_anonymous_$_anonymous_$_anonymous_$_anonymous_$menuLink$slambda_gsf7u0_0($name, $$this$link) {
  var i = new (crowpayBottomNav$_anonymous_$_anonymous_$_anonymous_$_anonymous_$menuLink$slambda_gsf7u0())($name, $$this$link);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function Link$_get_to_$ref_jq7esp_1(p0) {
  return () => p0.zbv_1;
}
function Link$_set_to_$ref_i9gu5x_1(p0) {
  return (_this__u8e3s4) => {
    p0.kbw(_this__u8e3s4);
    return Unit_instance;
  };
}
var properties_initialized_navigation_kt_tf422y;
function _init_properties_navigation_kt__ocd2vo() {
  if (!properties_initialized_navigation_kt_tf422y) {
    properties_initialized_navigation_kt_tf422y = true;
    mostRecentNavSelection = Signal().hak('Home');
  }
}
//region block: exports
export {
  crowpayBottomNav as crowpayBottomNav2jsedy4v8rkye,
  crowpaySideNav as crowpaySideNavjkfnjr6prypg,
  get_mostRecentNavSelection as get_mostRecentNavSelectionqndzighpm5wa,
};
//endregion

//# sourceMappingURL=navigation.mjs.map
